import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { IncidentListItem as Incident, STAGE_CONFIG } from '../../models/incident.models';

@Component({
  selector: 'app-recent-incidents',
  templateUrl: './recent-incidents.html',
})
export class RecentIncidentsComponent {
  private router = inject(Router);

  incidents = input.required<Incident[]>();
  loading = input(false);
  viewAll = output<void>();

  navigateToDetail(id: string): void {
    this.router.navigate(['/incidents', id]);
  }

  protected stageStyle(stage: string): { background: string; color: string } {
    const cfg = STAGE_CONFIG[stage];
    if (cfg) return { background: cfg.bg, color: cfg.color };
    return { background: '#f1f5f9', color: '#475569' };
  }
}
